import React from 'react';
import { connect } from 'react-redux';
import { Routes } from '@common-packages/routes-definitions';

import AuthorizedCustomRoute from '../shared/authorization/authorizedCustomRoute';
import GlobalContextPage from '../shared/displayComponents/globalContextPage.component';
import { isFetchingGlobalContextSelector } from '../shared/store/selectors';
import { TEMP_STORE } from '../shared/store/storeHelpers';

import MemberReturns from './memberReturns.container';

const MemberReturnsPage = connect((state: TEMP_STORE) => ({
  isFetchingContext: isFetchingGlobalContextSelector(state),
}))(GlobalContextPage);

const MemberReturnsRoutes = () => (
  <AuthorizedCustomRoute
    exact
    path={Routes.memberReturns.MAIN}
    wrapper={MemberReturnsPage}
    component={MemberReturns}
    hideGlobalContext
    disableBreadcrumbs
  />
);

export default MemberReturnsRoutes;
